import { createContext, type ReactNode } from 'react'

import { useExtensionShadowDom } from '../hooks/use-extension-shadow-dom'
import { useExtensionSidePanel } from '../hooks/use-extension-side-panel'
import { useNotchSuppression } from '../hooks/use-notch-suppression'

export interface NotchContextValue {
  isSidePanelOpen: boolean
  suppressRealNotch: boolean
  setSuppressRealNotch: (suppressRealNotch: boolean) => void
}

export const NotchContext = createContext<NotchContextValue | undefined>(undefined)

export const SidePanelHasBeenOpenedContext = createContext<boolean>(false)

export const NotchProvider = ({ children }: { children: ReactNode }) => {
  const shadowDom = useExtensionShadowDom()
  const { isSidePanelOpen, hasSidePanelBeenOpened } = useExtensionSidePanel(shadowDom)
  const { suppressRealNotch, setSuppressRealNotch } = useNotchSuppression(hasSidePanelBeenOpened)

  return (
    <NotchContext.Provider
      value={{
        isSidePanelOpen,
        suppressRealNotch,
        setSuppressRealNotch,
      }}
    >
      <SidePanelHasBeenOpenedContext.Provider value={hasSidePanelBeenOpened}>
        {children}
      </SidePanelHasBeenOpenedContext.Provider>
    </NotchContext.Provider>
  )
}
